import script from "./QuanLyDanhMuc.vue?vue&type=script&setup=true&lang=js"
export * from "./QuanLyDanhMuc.vue?vue&type=script&setup=true&lang=js"

import "./QuanLyDanhMuc.vue?vue&type=style&index=0&id=5bdcb037&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bdcb037"]])

export default __exports__